import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, API } from "@/lib/api";

const media = (p) => `${API}/events/media/${p}?auth=${encodeURIComponent(localStorage.getItem("sv_token") || "")}`;
const today = () => new Date().toLocaleDateString("en-CA", { timeZone: "America/Chicago" });

function text(v) {
  const who = v.customer || (v.fleet ? `OWN TRUCK ${v.fleet_label || ""}` : v.plate ? `plate ${v.plate}` : "plate not read");
  if (v.needs_review) return [`Truck left ${v.dock} — count needs review`, who, "#FF9F0A"];
  if (v.direction === "loading") return [`LOADED +${v.loaded} slabs · ${v.dock}`, who, "#30D158"];
  if (v.direction === "unloading") return [`UNLOADED −${v.unloaded} slabs · ${v.dock}`, who, "#0A84FF"];
  return [`Truck left ${v.dock} — no slabs moved`, who, "#A1A1AA"];
}

// Pops a photo + slab count on screen the moment a truck visit is finished (in place of a text message).
export function LoadingAlerts() {
  const seen = useRef(null);
  const nav = useNavigate();
  useEffect(() => {
    const poll = () => api.get(`/avstone/dock?date=${today()}`).then(({ data }) => {
      const done = (data.rows || []).filter((r) => r.status === "done" && r.direction && !["at_dock", "container"].includes(r.direction));
      if (seen.current === null) { seen.current = new Set(done.map((r) => r.id)); return; }
      done.filter((r) => !seen.current.has(r.id)).forEach((v) => {
        seen.current.add(v.id);
        const [title, who, col] = text(v);
        const img = (v.depart_images || v.arrive_images || [])[0];
        toast.custom((id) => (
          <button onClick={() => { toast.dismiss(id); nav("/avstone/loading"); }} className="flex gap-3 items-center bg-[#0A0A0C] border p-2 text-left w-[360px]" style={{ borderColor: col }} data-testid={`loading-alert-${v.id}`}>
            {img && <img src={media(img)} alt="truck" className="w-28 h-16 object-cover" />}
            <div className="min-w-0">
              <div className="text-sm font-bold" style={{ color: col }}>{title}</div>
              <div className="text-xs text-[#A1A1AA] truncate">{who}</div>
              <div className="text-[10px] font-mono-data text-[#71717A]">tap to open Truck Loading</div>
            </div>
          </button>
        ), { duration: 60000 });
      });
    }).catch(() => {});
    poll();
    const t = setInterval(poll, 20000);
    return () => clearInterval(t);
  }, [nav]);
  return null;
}
